import { Navigate, Outlet, useLocation, useOutletContext } from "react-router-dom";
import type { PlatformAdmin } from "@/types/api";
import { can } from "@/auth/capabilities";
import { platformCapabilityForPath } from "./access";

// Capability gate for the console, the platform counterpart of app/CapabilityRoute
// (6.6): PlatformProtectedRoute answers "is there a platform session, and has the
// forced password change cleared?", this answers "may THIS admin open this screen?".
// A support admin who follows a link to /platform/admins lands on the dashboard
// instead of a 403 page.
//
// It sits between the session guard and PlatformLayout, so it must pass the admin
// on: the layout and every console page read it from outlet context.
export function PlatformCapabilityRoute() {
  const admin = useOutletContext<PlatformAdmin | null>();
  const { pathname } = useLocation();

  const need = platformCapabilityForPath(pathname);
  if (need && !can(admin?.capabilities, need)) return <Navigate to="/platform" replace />;
  return <Outlet context={admin satisfies PlatformAdmin | null} />;
}
